import { fetchUtils } from '../utils/fetch.utils';
import { getAPIUrl } from '../utils/config.utils';

const BASE_URL = getAPIUrl();

function getGroups(pageSize) {
//   const query = fetchUtils.buildQuery(params);
//hardcoded for now
  return fetchUtils.get(`${BASE_URL}/groups?limit=100`);
}

function getTwentyMinPromise(dependent_id) {
  return fetchUtils.newGet(
    `${BASE_URL}/guardians/get-twenty-minut-promise/${dependent_id}`
  );
}

function createTwentyMinPromise(data) {
  return fetchUtils.post(`${BASE_URL}/guardians/twenty-minut-promise`, data);
}

function updateTwentyMinPromise(promise_id, data) {
  return fetchUtils.put(
    `${BASE_URL}/guardians/twenty-minut-promise/update?id=${promise_id}`,
    data
  );
}

export const groupRepository = {
  getGroups,
  getTwentyMinPromise,
  createTwentyMinPromise,
  updateTwentyMinPromise,
};
